export const conformiteMenuItems: any[] = [
	{
		labelKey: 'menu.dashboard',
		icon: 'pi pi-home',
		state: 'abonne-courant.tableau-de-bord',
	},

	{
		labelKey: 'menu.assessments',
		icon: 'pi pi-list-check',
		state: 'abonne-courant.evaluations'
	}
];
